<template>
  <div class="routing-dropzone">
    <draggable class="dropzone-items" v-show="items.length > 0" v-model="items">
      <div class="dropzone-item" v-for="(item, index) in items" :key="index">
        <div class="header">
          <span class="order">{{ index + 1}}</span>
          <a :href="'/#/reservation/' + item.id" target="_blank">{{ item.id }}</a>
          <!-- <span class="icon-label">
            <i class="fas fa-suitcase"></i>
            <span>{{ item.luggage }}</span>
          </span>
          <span class="icon-label">
            <i class="fas fa-user"></i>
            <span>{{ item.pax }}</span>
          </span> -->
          <span class="icon-label location">
            <i class="fas fa-map-marker-alt fa-fw"></i>
            <span>{{ getAddress(item.pickup) }}</span>
          </span>
          <span class="icon-label location">
            <i class="fas fa-map-marker-alt fa-fw dropoff"></i>
            <span>{{ getAddress(item.dropoff) }}</span>
          </span>
        </div>

        <div class="body">
          <span class="icon-label time">
            <i class="fas fa-clock"></i>
            <span class="label">PUT:</span>
            <span class="value">{{ item.pickupDate }}</span>
          </span>
          <span class="icon-label time">
            <i class="fas fa-clock"></i>
            <span class="label">ETA:</span>
            <span class="value">{{ computeEta(item) }}</span>
          </span>
          <span :class="['icon-label validation', hasIssues(item, index).time]" v-if="item.timeToNext != null">
            <i class="fas fa-exclamation-triangle fa-fw warning"></i>
            <i class="fas fa-check-circle fa-fw success"></i>
            <span v-html="hasIssues(item, index).msg"></span>
          </span>
        </div>

        <a class="remove-item" @click="removeFromMap(item)">
          <i class="fas fa-minus-square"></i>
        </a>
      </div>
    </draggable>

    <dropzone-controls ref="dropzoneControls"></dropzone-controls>

    <div :class="['check-route-loading', {show: checkRouteLoading}]">
      <loader-map-marker></loader-map-marker>
      <div class="title">
        <div class="text">Finding optimal route...</div>
      </div>
    </div>

    <div class="empty-container" v-show="items.length <= 0">
      <div class="empty">
        <div class="empty-content">
          <img src="/assets/img/routing-empty.png" />
          <div class="title">Nothing here yet!</div>
          <div class="message">Drop a reservation/runs here or click on the map marker icons to begin routing.</div>
        </div>
      </div>
    </div>

    <drop :class="['empty-container dropzone', {show: showDropzone}]" @drop="handleDrop">
      <div class="empty">
        <div class="empty-content">
          <i class="fas fa-arrow-alt-circle-down fa-4x"></i>
          <div class="title">Drop it here!</div>
        </div>
      </div>
    </drop>
  </div>
</template>

<script>
import moment from 'moment'
import Draggable from 'vuedraggable'
import DropzoneControls from './DropzoneControls'
import LoaderMapMarker from '@/components/Partials/LoadingAnimation/MapMarker'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'drop-zone',
  components: { Draggable, DropzoneControls, LoaderMapMarker },
  data () {
    return {
      overDropZone: false,
      issueDelay: '',
      issueList: []
    }
  },
  computed: {
    airports () { return this.$store.state.airports.list },
    dropzone () { return this.$store.state.runs.dropzone },
    items: {
      get () { return this.dropzone.items },
      set (value) {
        // a rsvp dropoff should not occur before pickup
        for (let i = 0; i < value.length; i++) {
          value[i].timeToNext = null
        }
        this.$store.commit('runs/setDropzoneData', {items: value})
        this.recheckIssue()
      }
    },
    showDropzone () { return this.dropzone.show },
    checkRouteLoading () { return this.dropzone.checkRoute },
    calculatingRun () { return this.dropzone.calculatingRun }
  },
  methods: {
    handleDrop (data) {
      data.rsvps.forEach(rsvp => {
        if (data.type === 'runs') {
          rsvp.runId = data.id
        }
        this.$store.commit('runs/addDropzoneItem', rsvp)
        this.recheckIssue()
      })
    },
    computeEta (rsvp) {
      return moment(rsvp.pickupDate, 'MM/DD/YYYY hh:mmA').add(rsvp.eta, 'seconds').format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
    },
    hasIssues (rsvp, index) {
      let self = this
      if (index + 1 >= self.items.length) {
        return {
          time: 'ontime',
          msg: ''
        }
      }

      let time = 'ontime'
      self.issueList[index] = 'ontime'

      let eta = moment(rsvp.pickupDate, 'MM/DD/YYYY hh:mmA').add(rsvp.eta, 'seconds').add(rsvp.timeToNext, 'seconds')
      let nextPickup = moment(self.items[index + 1].pickupDate, 'MM/DD/YYYY hh:mmA')
      if (eta.isAfter(nextPickup)) {
        time = 'late'
        if (eta.diff(nextPickup, 'minutes') > 15) time = 'not-allowed'
        self.issueList[index] = time
      }

      return {
        time: time,
        msg: `Will arrive at <b>${eta.format('MM/DD/YYYY hh:mmA')}</b> on the next Pickup.`
      }
    },
    getAddress (loc) {
      let index = this.airports.findIndex(x => x.geofenceId === loc.geofenceId)
      if (index > -1) return this.airports[index].title
      return loc.title
    },
    removeFromMap (item) {
      this.$store.commit('runs/removeDropzoneItem', item)
      this.recheckIssue()
    },
    recheckIssue () {
      let self = this
      if (self.issueDelay) clearTimeout(self.issueDelay)
      
      self.issueList = []
      self.issueDelay = setTimeout(() => {
        self.items.forEach((rsvp, index) => {
          if (index + 1 >= self.items.length) return
          
          let time = ''
          // self.issueList[index] = 'ontime'
          
          let eta = moment(rsvp.pickupDate, 'MM/DD/YYYY hh:mmA').add(rsvp.eta, 'seconds').add(rsvp.timeToNext, 'seconds')
          let nextPickup = moment(self.items[index + 1].pickupDate, 'MM/DD/YYYY hh:mmA')
          if (eta.isAfter(nextPickup)) {
            time = 'late'
            if (eta.diff(nextPickup, 'minutes') > 15) time = 'not-allowed'
          } else time = 'ontime'
          self.issueList[index] = time
        })
        if (self.$refs.dropzoneControls) self.$refs.dropzoneControls.updateIssue(self.issueList)
        self.$forceUpdate()
      }, 250)
    }
  },
  watch: {
    items () {
      this.$forceUpdate()
      this.recheckIssue()
    }
  }
}
</script>

<style lang="scss" scoped>
.routing-dropzone{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.empty-container {
  display: table;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0);
  transition: all 500ms;

  &.dragover {
    background-color: rgba(0,0,0,0.6);
  }

  & .empty {
    display: table-cell;
    vertical-align: middle;
  }

  & .empty-content {
    max-width: 350px;
    padding: 0 15px;
    margin: 0 auto;
    text-align: center;
    font-weight: 700;

    & img {
      display: block;
      width: 200px;
      margin: 0 auto;
    }

    & .title {
      font-size: 22px;
      color: #3F2975;
      margin-top: 15px;
    }
    & .message {
      margin-top: 5px;
      font-size: 16px;
      color: #555;
    }
  }
}


.dropzone {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.75);
  transition: all 250ms;

  &.show { top: 0; }

  & .empty-content i { color: #fff; }
  & .empty-content .title{ color: #fff; }
}

.dropzone-items {
  padding: 10px 10px 5px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 70px);
  overflow: auto;
}
.dropzone-item {
  position: relative;
  background-color: #fff;
  margin-bottom: 5px;
  border: 1px solid rgba(0,0,0,0.3);
  border-radius: 3px;

  & .remove-item {
    position: absolute;
    top: 17px;
    right: 10px;
    text-decoration: none;
    color: #F20D0D;
    cursor: pointer;
  }

  & a { font-weight: 700; }

  & .header {
    font-size: 12px;
    padding: 5px;
  }

  & .order {
    display: inline-block;
    margin-right: 5px;
    background-color: #5d5d5d;
    color: #fff;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-weight: 700;
    border-radius: 100%;
    &.dropoff { background-color: #F20D0D; }
  }

  & .icon-label {
    display: inline-block;
    margin-left: 10px;
    color: #555;

    &.location {
      margin: 0;
      padding: 0 25px 0 5px;
      color: #555;
      font-weight: 700;
      display: block;
      margin: 5px 0;

      & i{ color: #26D97A; }
      & i.dropoff{ color: #F20D0D; }
    }

    &.time {
      & .value { font-weight: 700; }
    }

    &.validation {
      color: #229e5c;
      & i.success { display: inline-block; }
      & i.warning { display: none; }
      &.late {
        color: #F25E0D;
        & i.success { display: none; }
        & i.warning{ display: inline-block; }
      }
      &.not-allowed {
        color: #f20d0d;
        & i.success { display: none; }
        & i.warning{ display: inline-block; }
      }
    }
  }

  & .body {
    font-size: 12px;
    padding: 0 15px 10px 23px;
    text-align: left;
  }
}

.check-route-loading {
  display: table;
  position: absolute;
  bottom: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.9);
  transition: all 250ms;
  &.show{ bottom: 0; }

  & .title {
    display: table-cell;
    vertical-align: middle;
    width: 100%;
    height: 100%;
    text-align: center;
    color: #555;
    font-weight: 700;
    font-size: 18px;

    & .text {
      display: inline-block;
      margin-top: 100px;
    }
  }
}

@media screen and (max-width: 430px) {
  .dropzone-item {
    margin-bottom: 10px;
  }
  .dropzone-items {
    height: 100%;
    padding: 20px 40px;
    padding-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Runs/Dropzone.vue